'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSimilarItemsUrl = exports.getSearchAuctioneerSoldUrl = exports.getSearchAuctioneerUrl = exports.separateURL = exports.getCategoryPageUrlFromObject = exports.getCategoryLandingPageUrlFromCategoryName = exports.getSearchPageMostBids = exports.getSearchPageMostPopular = exports.getAdQuestionUrl = exports.getDeskSupportEmail = exports.getMegaNavImageUrlSmall = exports.getMegaNavImageUrlLarge = exports.getCoverLotPrimaryImageUrlSmall = exports.getCoverLotPrimaryImageUrlLarge = exports.getCoverLotPrimaryImageUrl = exports.getItemCardImageUrl = exports.getCuratorImageUrl = exports.getCoverLotSecondaryImageUrlSmall = exports.getCoverLotSecondaryImageUrlLarge = exports.getCoverLotSecondaryImageUrl = exports.getItemImageUrl = exports.getXLargeItemImageUrl = exports.getLargeItemImageUrl = exports.getMediumItemImageUrl = exports.getPlaceholderItemImageUrl = exports.getThumbnailItemImageUrl = exports.getAllUpcomingAuctionsUrl = exports.getAuctioneerLogoUrl = exports.addImageQueryParams = exports.setQueryParams = exports.getWonItemsPageUrl = exports.getTermsAndConditionsUrl = exports.getTerminologyUrl = exports.getSupportUrl = exports.getSellerUrl = exports.getSellPageUrl = exports.getSavedSearchesUrl = exports.getSavedItemsUrl = exports.getProfileUrl = exports.getPrivacyUrl = exports.getPriceGuideUrl = exports.getPriceGuideBaseUrl = exports.getNotFoundUrl = exports.getNewsUrl = exports.getNewCatalogConsoleUrl = exports.getNearMeUrl = exports.getMyBidsUrl = exports.getMyAuctionsUrl = exports.getMobileUrl = exports.getLiveBiddingUrl = exports.getItemUrl = exports.getIntellectualPropertyUrl = exports.getHomeUrl = exports.getFollowedSellersUrl = exports.getCookiePolicyUrl = exports.getConsignmentsUrl = exports.getCheckoutConfirmationUrl = exports.getCategoryLandingPageBaseUrl = exports.getCatalogUrl = exports.getCatalogConsoleUrl = exports.getAuctioneerDirectoryUrl = exports.getAuctionResultsUrl = exports.getCategoryFacetLink = exports.getCategoryUrlWithParams = exports.getSearchUrlWithParams = exports.getCatalogSearchUrlWithParams = exports.getParamsFromQueryString = exports.safeTitle = exports.signupLadySmallUrl = exports.logoUrl = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoUrl = exports.logoUrl = 'https://p1.liveauctioneers.com/dist/images/logo_og.jpg?format=pjpg&auto=webp&quality=50';
var signupLadySmallUrl = exports.signupLadySmallUrl = 'https://p1.liveauctioneers.com/dist/images/SignupLadySmall.png?auto=webp&quality=50';

var safeTitle = exports.safeTitle = function safeTitle() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var safe = title.trim()
    // & to and
    .replace(/&/g, 'and')
    // comma to hyphen
    .replace(/,+/g, '-')
    // * to hyphen
    .replace(/\*+/g, '-')
    // ; to hyphen
    .replace(/;+/g, '-')
    // : to hyphen
    .replace(/:+/g, '-')
    // ' to hyphen
    .replace(/'+/g, '-')
    // " to hyphen
    .replace(/"+/g, '-').replace(/-*\s+-*/g, '-')
    // non letter/digit/& to nothing
    .replace(/[^a-zA-Z0-9-_&]/g, '')
    // many hyphen to one
    .replace(/--+/g, '-').toLowerCase();
    return safe;
};

// Based off https://stackoverflow.com/a/3855394/148256
var getParamsFromQueryString = exports.getParamsFromQueryString = function getParamsFromQueryString(queryString) {
    if (!queryString) {
        return {};
    }

    var params = (/^[?#]/.test(queryString) ? queryString.slice(1) : queryString).split('&').reduce(function (params, param) {
        try {
            var _param$split = param.split('='),
                _param$split2 = (0, _slicedToArray3.default)(_param$split, 2),
                k = _param$split2[0],
                v = _param$split2[1];

            var key = decodeURIComponent(k.replace(/\+/g, ' ')) || '';
            // Lowercasing the keys will make the front end code cleaner (and hopefully will not break things)
            key = key.toLowerCase();
            // There might not be an equals ?foo is valid, foo is set to true
            var value = typeof v === 'undefined' ? true : decodeURIComponent(v.replace(/\+/g, ' ')) || '';
            // If there is a key, and it is not a duplicate, set it
            if (key && !params[key]) {
                // Clean up the nasty parameters object
                params[key] = key === 'parameters' ? JSON.parse(value) : value;
            }
        } catch (err) {
            // If we catch an error, don't alter params, the reduce funtion will continue on without that param
        }
        return params;
    }, {});

    return params;
};

var buildQueryString = function buildQueryString(params) {
    var arr = [];

    for (var key in params) {
        var value = params[key];
        if (key === 'page' && value === '1' || !value) {
            continue;
        }
        arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }

    return arr.length > 0 ? '?' + arr.join('&') : '';
};

var buildSearchUrl = function buildSearchUrl(base, params) {
    var queryString = buildQueryString(params);
    return '' + base + queryString;
};

var getCatalogSearchBaseUrl = function getCatalogSearchBaseUrl() {
    return '/catalog/search/';
};
var getCatalogSearchUrlWithParams = exports.getCatalogSearchUrlWithParams = function getCatalogSearchUrlWithParams(params) {
    var base = getCatalogSearchBaseUrl();
    return buildSearchUrl(base, params);
};

var getSearchBaseUrl = function getSearchBaseUrl() {
    return '/search/';
};
var getSearchUrlWithParams = exports.getSearchUrlWithParams = function getSearchUrlWithParams(params) {
    var base = getSearchBaseUrl();
    return buildSearchUrl(base, params);
};

var getCategoryUrlWithParams = exports.getCategoryUrlWithParams = function getCategoryUrlWithParams(base, params) {
    return buildSearchUrl(base, params);
};

var getCategoryFacetLink = exports.getCategoryFacetLink = function getCategoryFacetLink(base, params) {
    base = base === '' || base === undefined ? '/c/' : '/c/' + base + '/';
    return buildSearchUrl(base, params);
};

var getAuctionResultsUrl = exports.getAuctionResultsUrl = function getAuctionResultsUrl() {
    return '/auction-results';
};
var getAuctioneerDirectoryUrl = exports.getAuctioneerDirectoryUrl = function getAuctioneerDirectoryUrl() {
    return '/auctioneer/directory/';
};
var getCatalogConsoleUrl = exports.getCatalogConsoleUrl = function getCatalogConsoleUrl(baseUrl, id) {
    return baseUrl + '/bidapplet' + id;
};
var getCatalogUrl = exports.getCatalogUrl = function getCatalogUrl(id, title) {
    return '/catalog/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
};
var getCategoryLandingPageBaseUrl = exports.getCategoryLandingPageBaseUrl = function getCategoryLandingPageBaseUrl() {
    return '/c/';
};
var getCheckoutConfirmationUrl = exports.getCheckoutConfirmationUrl = function getCheckoutConfirmationUrl(sellerId, itemId) {
    return '/confirmation/' + sellerId + '/' + itemId;
};
var getConsignmentsUrl = exports.getConsignmentsUrl = function getConsignmentsUrl() {
    return '/consignments';
};
var getCookiePolicyUrl = exports.getCookiePolicyUrl = function getCookiePolicyUrl() {
    return '/cookie-policy';
};
var getFollowedSellersUrl = exports.getFollowedSellersUrl = function getFollowedSellersUrl() {
    return '/dashboard/followed-auctioneers';
};
var getHomeUrl = exports.getHomeUrl = function getHomeUrl() {
    return '/';
};
var getIntellectualPropertyUrl = exports.getIntellectualPropertyUrl = function getIntellectualPropertyUrl() {
    return '/intellectualproperty';
};
var getItemUrl = exports.getItemUrl = function getItemUrl(id, title) {
    return '/item/' + id + '_' + safeTitle(title).replace(/-+$/, '');
};
var getLiveBiddingUrl = exports.getLiveBiddingUrl = function getLiveBiddingUrl(catalogId) {
    return '/console/' + catalogId;
};
var getMobileUrl = exports.getMobileUrl = function getMobileUrl() {
    return '/mobile';
};
var getMyAuctionsUrl = exports.getMyAuctionsUrl = function getMyAuctionsUrl() {
    return '/dashboard/my-auctions';
};
var getMyBidsUrl = exports.getMyBidsUrl = function getMyBidsUrl() {
    return '/dashboard/my-bids';
};
var getNearMeUrl = exports.getNearMeUrl = function getNearMeUrl() {
    return '/find-auctions-near-me';
};
var getNewCatalogConsoleUrl = exports.getNewCatalogConsoleUrl = function getNewCatalogConsoleUrl(id, title) {
    return '/console/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
};
var getNewsUrl = exports.getNewsUrl = function getNewsUrl(baseUrl) {
    return baseUrl + '/news/';
};
var getNotFoundUrl = exports.getNotFoundUrl = function getNotFoundUrl() {
    return '/not-found';
};
var getPriceGuideBaseUrl = exports.getPriceGuideBaseUrl = function getPriceGuideBaseUrl() {
    return '/price-guide/';
};
var getPriceGuideUrl = exports.getPriceGuideUrl = function getPriceGuideUrl(name, id) {
    return '' + getPriceGuideBaseUrl() + name + '/' + id + '/';
};
var getPrivacyUrl = exports.getPrivacyUrl = function getPrivacyUrl() {
    return '/privacy';
};
var getProfileUrl = exports.getProfileUrl = function getProfileUrl() {
    return '/dashboard/profile';
};
var getSavedItemsUrl = exports.getSavedItemsUrl = function getSavedItemsUrl() {
    return '/dashboard/saved-items';
};
var getSavedSearchesUrl = exports.getSavedSearchesUrl = function getSavedSearchesUrl(append) {
    return '/dashboard/search-and-alerts/' + (append ? append + '/' : '');
};
var getSellPageUrl = exports.getSellPageUrl = function getSellPageUrl(baseUrl) {
    return baseUrl + '/pages/sell/';
};
var getSellerUrl = exports.getSellerUrl = function getSellerUrl(id, title) {
    return '/auctioneer/' + id + '/' + safeTitle(title).replace(/-+$/, '') + '/';
};
var getSupportUrl = exports.getSupportUrl = function getSupportUrl() {
    return 'https://liveauctioneers.desk.com';
};
var getTerminologyUrl = exports.getTerminologyUrl = function getTerminologyUrl() {
    return '/terminology';
};
var getTermsAndConditionsUrl = exports.getTermsAndConditionsUrl = function getTermsAndConditionsUrl() {
    return '/termsandconditions';
};
var getWonItemsPageUrl = exports.getWonItemsPageUrl = function getWonItemsPageUrl() {
    return '/dashboard/won-items';
};

var setQueryParams = exports.setQueryParams = function setQueryParams(url) {
    var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var cleanedUrl = url.replace(/\?.*/, '');
    var queryString = buildQueryString(queryParams);
    return '' + cleanedUrl + queryString;
};

var addImageQueryParams = exports.addImageQueryParams = function addImageQueryParams(url, width) {
    var correctImageUrl = url.replace('http://', 'https://');
    return correctImageUrl + '?width=' + width + '&auto=webp&format=pjpg';
};

var getAuctioneerLogoUrl = exports.getAuctioneerLogoUrl = function getAuctioneerLogoUrl(auctioneer) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 110;

    return 'https://images.liveauctioneers.com/houses/logos/lg/' + auctioneer + '_large.jpg?width=' + width + '&format=pjpg&auto=webp&quality=100';
};

var getAllUpcomingAuctionsUrl = exports.getAllUpcomingAuctionsUrl = function getAllUpcomingAuctionsUrl() {
    return getCatalogSearchUrlWithParams();
};

var generateImageUrl = function generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, size) {
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var cropImage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    if (!sellerId || !catalogId || !itemId || !imgNumber) {
        return '';
    }

    var quality = limitQuality ? '&quality=50' : '';
    var crop = cropImage ? '&crop=' + cropImage : '';

    return 'https://p1.liveauctioneers.com/' + sellerId + '/' + catalogId + '/' + itemId + '_' + imgNumber + '_x.jpg?version=' + imageVersion + (size ? '&width=' + size : '') + '&format=pjpg&auto=webp' + quality + crop;
};

var generateThumbnailImageUrl = function generateThumbnailImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, size) {
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var quality = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 50;
    var cropImage = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

    if (!sellerId || !catalogId || !itemId || !imgNumber) {
        return '';
    }

    var imageQuality = limitQuality ? '&quality=' + quality : '';
    var crop = cropImage ? '&crop=' + cropImage : '';

    return 'https://p1.liveauctioneers.com/' + sellerId + '/' + catalogId + '/' + itemId + '_' + imgNumber + '_x.jpg?version=' + imageVersion + (size ? '&width=' + size : '') + '&format=pjpg&auto=webp' + imageQuality + crop;
};

var getThumbnailItemImageUrl = exports.getThumbnailItemImageUrl = function getThumbnailItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var width = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 128;
    return generateThumbnailImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, width, true, 25);
};

var getPlaceholderItemImageUrl = exports.getPlaceholderItemImageUrl = function getPlaceholderItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateThumbnailImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 612, true, 10);
};

var getMediumItemImageUrl = exports.getMediumItemImageUrl = function getMediumItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 512);
};

var getLargeItemImageUrl = exports.getLargeItemImageUrl = function getLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 768);
};

var getXLargeItemImageUrl = exports.getXLargeItemImageUrl = function getXLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, false, true);
};

var getItemImageUrl = exports.getItemImageUrl = function getItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var width = arguments[5];
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var crop = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, width, limitQuality, crop);
};

var getCoverLotSecondaryImageUrl = exports.getCoverLotSecondaryImageUrl = function getCoverLotSecondaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 170 : 130);
};

var getCoverLotSecondaryImageUrlLarge = exports.getCoverLotSecondaryImageUrlLarge = function getCoverLotSecondaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 202);
};

var getCoverLotSecondaryImageUrlSmall = exports.getCoverLotSecondaryImageUrlSmall = function getCoverLotSecondaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 105);
};

var getCuratorImageUrl = exports.getCuratorImageUrl = function getCuratorImageUrl(baseUrl, curatorId, curatorImageFileName) {
    return baseUrl + '/' + curatorId + '/' + curatorImageFileName;
};

var getItemCardImageUrl = exports.getItemCardImageUrl = function getItemCardImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 280);
};

var getCoverLotPrimaryImageUrl = exports.getCoverLotPrimaryImageUrl = function getCoverLotPrimaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 340 : 250);
};

var getCoverLotPrimaryImageUrlLarge = exports.getCoverLotPrimaryImageUrlLarge = function getCoverLotPrimaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 410);
};

var getCoverLotPrimaryImageUrlSmall = exports.getCoverLotPrimaryImageUrlSmall = function getCoverLotPrimaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 210);
};

var getMegaNavImageUrlLarge = exports.getMegaNavImageUrlLarge = function getMegaNavImageUrlLarge(category) {
    return 'https://p1.liveauctioneers.com/dist/images/desktop-' + category + '.jpg?height=382&format=pjpg&auto=webp&quality=50';
};

var getMegaNavImageUrlSmall = exports.getMegaNavImageUrlSmall = function getMegaNavImageUrlSmall(category) {
    return 'https://p1.liveauctioneers.com/dist/images/tablet-' + category + '.jpg?height=288&format=pjpg&auto=webp&quality=50';
};

var getDeskSupportEmail = exports.getDeskSupportEmail = function getDeskSupportEmail(name, email) {
    var fields = [];
    name && fields.push('interaction[name]=' + encodeURIComponent(name));
    email && fields.push('interaction[email]=' + email);

    return 'https://liveauctioneers.desk.com/customer/portal/emails/new' + (fields.length ? '?' + fields.join('&') : '');
};

var getAdQuestionUrl = exports.getAdQuestionUrl = function getAdQuestionUrl() {
    return 'https://www.surveymonkey.com/r/KFCCVSX';
};

var getSearchPageMostPopular = exports.getSearchPageMostPopular = function getSearchPageMostPopular() {
    return getSearchUrlWithParams({ page: 1, sort: '-popularity' });
};
var getSearchPageMostBids = exports.getSearchPageMostBids = function getSearchPageMostBids() {
    return getSearchUrlWithParams({ page: 1, sort: '-bidCount' });
};

var categoryLandingIds = {
    art: 1,
    asian: 158,
    collectibles: 2,
    fashion: 3,
    furniture: 4,
    'home-garden': 5,
    jewelry: 6
};

var getCategoryLandingPageUrlFromCategoryName = exports.getCategoryLandingPageUrlFromCategoryName = function getCategoryLandingPageUrlFromCategoryName(category) {
    var categoryId = categoryLandingIds[category];
    return categoryId ? '' + getCategoryLandingPageBaseUrl() + category + '/' + categoryId + '/' : getCategoryLandingPageBaseUrl();
};

var getCategoryPageUrlFromObject = exports.getCategoryPageUrlFromObject = function getCategoryPageUrlFromObject(category) {
    var url = getCategoryLandingPageBaseUrl();
    if (!category || !category.l1CategoryId) {
        return url;
    }
    url += category.l1CategoryUrl + '/';
    if ((0, _typeof3.default)(category.l2CategoryId) !== undefined && category.l2CategoryId) {
        url += category.l2CategoryUrl + '/' + category.l1CategoryId + '/' + category.l2CategoryId + '/';
    } else {
        url += category.l1CategoryId + '/';
    }
    return url;
};

var separateURL = exports.separateURL = function separateURL(url) {
    var match = url.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (match === null) {
        return {
            host: '',
            path: ''
        };
    }
    return {
        host: match[2],
        path: match[5]
    };
};

var getSearchAuctioneerUrl = exports.getSearchAuctioneerUrl = function getSearchAuctioneerUrl(sellerId) {
    return getSearchUrlWithParams({ house_id: '' + sellerId, page: 1, sort: '-popularity' });
};

var getSearchAuctioneerSoldUrl = exports.getSearchAuctioneerSoldUrl = function getSearchAuctioneerSoldUrl(sellerId) {
    return getSearchUrlWithParams({ house_id: '' + sellerId, page: 1, status: 'archive' });
};

var getSimilarItemsUrl = exports.getSimilarItemsUrl = function getSimilarItemsUrl() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sellerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var keyword = title.split(/\s+/g).map(function (word) {
        return '"' + word + '"';
    }).join(' OR ').replace(/"/g, '\\"');
    var params = { keyword: keyword, status: ['online', 'live', 'upcoming'] };
    if (sellerId) {
        params.house_id = sellerId.toString();
    }
    return getSearchUrlWithParams(params);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/urls.js
// module id = CakR
// module chunks = 60